import { STORE_ONBOARDING_REQUESTS } from '../../constants/onboarding';

const initialState = {
  requests: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_ONBOARDING_REQUESTS:
      return {
        ...state,
        requests: action.requests || [],
      };
    default:
      return state;
  }
};
